import React from 'react';

const item = ( props ) => {
   let doctor = '';
   let specialty = '';
   if("doctor" in props.itemData) {
      doctor = (
         <div class="feed_author"><i class="fas fa-user-md"></i> <span>{props.itemData.doctor}</span></div>
      );
   }
   if("specialty" in props.itemData && props.itemData.specialty.length > 1) {
      specialty = (
         <div class="feed_category"><i class="fas fa-folder"></i><span>{props.itemData.specialty}</span></div>
      );
   }
   return (
      <div class="feed">
         <div class="feed_head">
            <div class="feed_title">{props.itemData.title}</div>
         </div>
         <div class="feed_info">
            {doctor}
            {specialty}
          </div>
          <div class="feed_link">
            <a class="btn_white" href={props.itemData.link}>Read More</a>
          </div>
      </div>
   );


};

export default item;



// WEBPACK FOOTER //
// ./src/components/Item/Item.js